import { render } from "./DocCosignAutocomplete.vue?vue&type=template&id=5d88d8fa"
import script from "./DocCosignAutocomplete.vue?vue&type=script&lang=js"
export * from "./DocCosignAutocomplete.vue?vue&type=script&lang=js"

import "./DocCosignAutocomplete.vue?vue&type=style&index=0&id=5d88d8fa&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__